module.exports = __webpack_public_path__ + "6227b52e321e875c61a26b33bf617be6.svg";